var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.excluded)?_c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.crumbs}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }